import styled from "@emotion/styled";

export const TabsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${p => p.theme.space[4]}px;
  margin-bottom: 0;

  @media (min-width: ${p => p.theme.screenSizes.mdMax}) {
    gap: ${p => p.theme.space[5]}px;
    margin-bottom: 40px;
  }
`;

export const TabsList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: ${p => p.theme.space[4]}px;
  list-style: none;

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    gap: ${p => p.theme.space[5]}px;
  }
`;
